import { createStyles, makeStyles } from "@mui/styles";
import usePrimaryColor from "@root/hooks/usePrimaryColor";

export const MailButton = ({ title }: IMailButton) => {

    const { defPrimaryColor } = usePrimaryColor();
    const useStyles = makeStyles(() =>
        createStyles({
            button: {
                fontFamily: "Wix Madefor Text",
                fontSize: "16px",
                fontWeight: 700,
                borderRadius: "40px",
                backgroundColor: defPrimaryColor,
                color: "#ffffff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                maxWidth: "348px",
                width: "100%",
                padding: "14px 0",
                margin: "0 auto",
                
            },
        })
    );

    const classes = useStyles();

    return (
        <a
            href="mailto:support@cashd.com.au"
            className={classes.button}
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1712_5429)">
                    <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 10.99L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="white" />
                </g>
                <defs>
                    <clipPath id="clip0_1712_5429">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            {title}
        </a>
    );
};

interface IMailButton {
    title: string;
}